<template>
  <div :class="{ 'coupon-applied': couponMessage }">
    <div class="message" v-if="couponMessage">
      <p>{{ couponMessage }}</p>
    </div>
    <div class="login-container">
      <SignupWizard />
    </div>
  </div>
</template>
<script>
import SignupWizard from "@/components/Custom/SignupWizard";
export default {
  name: "Signup",
  components: {
    SignupWizard
  },
  data() {
    return {
      couponMessage: null
    };
  },
  mounted() {
    this.updateCouponMessage();
    if (
      this.$cookies.get("coupon") === "KLOUTED" &&
      !document.querySelector('script[src="//cdn.clkmc.com/cmc.js"]')
    ) {
      window.clickmagick_cmc = {
        uid: "157588",
        hid: "112900509",
        cmc_project: "Artist Hub",
        cmc_goal: "a",
        vid_info: "on"
      };
      const script = document.createElement("script");
      script.src = "//cdn.clkmc.com/cmc.js";
      document.head.appendChild(script);
    }
  },
  computed: {
    coupon() {
      return this.$cookies.get("coupon");
    }
  },
  methods: {
    updateCouponMessage() {
      if (this.coupon) {
        const couponMonths = this.$cookies.get("coupon_months");
        this.couponMessage = `🎁  You clicked a VIP link! Enjoy an extra ${couponMonths} free months when you sign up now!`;
      } else {
        this.couponMessage = null;
      }
    }
  },
  watch: {
    coupon() {
      this.updateCouponMessage();
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 600px) {
  .login-container {
    height: auto;
    min-height: 100vh;
  }
}
.coupon-applied {
  // padding-top: 32px;
  .message {
    background-color: #fff;
    color: #4a154b;
    padding: 10px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .login-container {
    // height: calc(100vh - 62px);
  }
}
</style>
